import Vue from 'vue'
import { Tag } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Tag)

export default Vue.extend({
  template: `
    <div>
      <a-tag color="#71283e" v-if="value">Yes</a-tag>
    </div>
    `,
  data: function() {
    return {
      value: null,
    }
  },
  beforeMount() {
    this.value = _.get(this.params, 'value', null)
  },
})
